// pages/Infrastructure.js
import React from "react";

const Infrastructure = () => {
  return (
    <div className="p-4">
      {/* Enhanced Header Section */}
      <div className="about-header text-center bg-primary gap-1 mb-6 py-5 border-round-xl" >
        <h1 className="text-2xl sm:text-4xl font-bold text-center mb-3 text-white">
          Our Infrastructure
        </h1>
        <p className="text-center text-base sm:text-lg mb-1 text-white px-3">
          Our school campus is thoughtfully designed to support learning, creativity, and overall development.
        </p>
        <p className="text-center text-base sm:text-lg mb-1 text-white px-3">
          From modern classrooms to dedicated activity zones, every space inspires students to learn and grow.
        </p>
      </div>

      <div className="bg-gradient-to-br from-blue-50 to-orange-50 py-5">
        <div className="container mx-auto px-4">

          {/* 1. Classrooms - Image Left */}
          <div className="mb-5 bg-white border-round-2xl shadow-2 overflow-hidden">
            <div className="flex flex-column lg:flex-row">
              <div className="lg:col-6 relative p-0">
                <img
                  src="/images/classroom.jpg"
                  alt="Classrooms"
                  className="w-full h-full object-cover"
                  style={{ minHeight: '400px' }}
                />
                <div className="absolute top-3 left-3 bg-orange-500 text-white px-3 py-2 border-round-xl font-bold">
                  📚 Learning Spaces
                </div>
              </div>
              <div className="lg:col-6 p-5 flex flex-column justify-content-center">
                <h3 className="text-3xl font-bold mb-3 text-primary" style={{ color: '#03438F' }}>Modern Classrooms</h3>
                <p className="text-lg text-700 mb-4 line-height-3">
                  Our classrooms are designed to inspire curiosity and foster collaboration. With natural lighting, comfortable seating, and interactive technology, we create the perfect environment for effective learning.
                </p>
                <div className="grid mb-4">
                  <div className="col-12 md:col-6 flex align-items-center mb-2">
                    <div className="bg-blue-100 p-2 border-round-lg mr-3"><span style={{ color: '#03438F' }}>✨</span></div>
                    <span className="text-700">Interactive Smart Boards</span>
                  </div>
                  <div className="col-12 md:col-6 flex align-items-center mb-2">
                    <div className="bg-blue-100 p-2 border-round-lg mr-3"><span style={{ color: '#03438F' }}>💡</span></div>
                    <span className="text-700">Natural Lighting</span>
                  </div>
                  <div className="col-12 md:col-6 flex align-items-center mb-2">
                    <div className="bg-blue-100 p-2 border-round-lg mr-3"><span style={{ color: '#03438F' }}>🪑</span></div>
                    <span className="text-700">Ergonomic Seating</span>
                  </div>
                  <div className="col-12 md:col-6 flex align-items-center mb-2">
                    <div className="bg-blue-100 p-2 border-round-lg mr-3"><span style={{ color: '#03438F' }}>🔊</span></div>
                    <span className="text-700">Audio-Visual Systems</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* 2. Composite Science Lab - Image Right */}
          <div className="mb-5 bg-white border-round-2xl shadow-2 overflow-hidden">
            <div className="flex flex-column lg:flex-row-reverse">
              <div className="lg:col-6 relative p-0">
                <img
                  src="/images/lab1.png"
                  alt="Composite Science Lab"
                  className="w-full h-full object-cover"
                  style={{ minHeight: '400px' }}
                />
                <div className="absolute top-3 right-3 bg-blue-600 text-white px-3 py-2 border-round-xl font-bold">
                  🔬 Science & Discovery
                </div>
              </div>
              <div className="lg:col-6 p-5 flex flex-column justify-content-center">
                <h3 className="text-3xl font-bold mb-3 text-primary" style={{ color: '#03438F' }}>Composite Science Lab</h3>
                <p className="text-lg text-700 mb-4 line-height-3">
                  Our composite science lab is a well‑equipped facility where students perform experiments in physics, chemistry, and biology. Regular practical sessions help students bridge the gap between theory and real‑world application.
                </p>
                <div className="grid mb-4">
                  <div className="col-12 md:col-6 flex align-items-center mb-2">
                    <div className="bg-orange-100 p-2 border-round-lg mr-3"><span style={{ color: '#F57A25' }}>⚗️</span></div>
                    <span className="text-700">Modern Apparatus</span>
                  </div>
                  <div className="col-12 md:col-6 flex align-items-center mb-2">
                    <div className="bg-orange-100 p-2 border-round-lg mr-3"><span style={{ color: '#F57A25' }}>🥽</span></div>
                    <span className="text-700">Strict Safety Measures</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* 3. Computer Lab - Image Left */}
          <div className="mb-5 bg-white border-round-2xl shadow-2 overflow-hidden">
            <div className="flex flex-column lg:flex-row">
              <div className="lg:col-6 relative p-0">
                <img
                  src="/images/computerlab.png"
                  alt="Computer Lab"
                  className="w-full h-full object-cover"
                  style={{ minHeight: '400px' }}
                />
                <div className="absolute top-3 left-3 bg-orange-500 text-white px-3 py-2 border-round-xl font-bold">
                  💻 Tech Hub
                </div>
              </div>
              <div className="lg:col-6 p-5 flex flex-column justify-content-center">
                <h3 className="text-3xl font-bold mb-3 text-primary" style={{ color: '#03438F' }}>Computer Lab</h3>
                <p className="text-lg text-700 mb-4 line-height-3">
                  The computer lab provides students with access to modern computers and the latest software, enabling them to develop digital literacy, coding, and programming skills in a high-speed internet environment.
                </p>
                <div className="grid mb-4">
                  <div className="col-12 md:col-6 flex align-items-center mb-2">
                    <div className="bg-blue-100 p-2 border-round-lg mr-3"><span style={{ color: '#03438F' }}>🖥️</span></div>
                    <span className="text-700">Latest Systems</span>
                  </div>
                  <div className="col-12 md:col-6 flex align-items-center mb-2">
                    <div className="bg-blue-100 p-2 border-round-lg mr-3"><span style={{ color: '#03438F' }}>🌐</span></div>
                    <span className="text-700">High-Speed Internet</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* 4. Library - Image Right */}
          <div className="mb-5 bg-white border-round-2xl shadow-2 overflow-hidden">
            <div className="flex flex-column lg:flex-row-reverse">
              <div className="lg:col-6 relative p-0">
                <img
                  src="/images/librrary.png"
                  alt="Library"
                  className="w-full h-full object-cover"
                  style={{ minHeight: '400px' }}
                />
                <div className="absolute top-3 right-3 bg-blue-600 text-white px-3 py-2 border-round-xl font-bold">
                  📖 Knowledge Center
                </div>
              </div>
              <div className="lg:col-6 p-5 flex flex-column justify-content-center">
                <h3 className="text-3xl font-bold mb-3 text-primary" style={{ color: '#03438F' }}>Library & Resource Center</h3>
                <p className="text-lg text-700 mb-4 line-height-3">
                  A quiet sanctuary for learning and discovery. Our library offers extensive collections, digital resources, and comfortable study spaces to support academic excellence and a love for reading.
                </p>
                <div className="grid mb-4">
                  <div className="col-12 md:col-6 flex align-items-center mb-2">
                    <div className="bg-orange-100 p-2 border-round-lg mr-3"><span style={{ color: '#F57A25' }}>📚</span></div>
                    <span className="text-700">Extensive Collection</span>
                  </div>
                  <div className="col-12 md:col-6 flex align-items-center mb-2">
                    <div className="bg-orange-100 p-2 border-round-lg mr-3"><span style={{ color: '#F57A25' }}>🛋️</span></div>
                    <span className="text-700">Quiet Study Areas</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* 5. Sports & Games - Image Left */}
          <div className="mb-5 bg-white border-round-2xl shadow-2 overflow-hidden">
            <div className="flex flex-column lg:flex-row">
              <div className="lg:col-6 relative p-0">
                <img
                  src="/images/sports.jpeg"
                  alt="Sports Facilities"
                  className="w-full h-full object-cover"
                  style={{ minHeight: '400px' }}
                />
                <div className="absolute top-3 left-3 bg-orange-500 text-white px-3 py-2 border-round-xl font-bold">
                  ⚽ Physical Education
                </div>
              </div>
              <div className="lg:col-6 p-5 flex flex-column justify-content-center">
                <h3 className="text-3xl font-bold mb-3 text-primary" style={{ color: '#03438F' }}>Sports & Games Facilities</h3>
                <p className="text-lg text-700 mb-4 line-height-3">
                  Physical fitness and teamwork are nurtured through our comprehensive sports program. From outdoor fields for cricket and football to indoor courts and a swimming pool, we offer diverse athletic opportunities.
                </p>
                <div className="grid mb-4">
                  <div className="col-12 md:col-6 flex align-items-center mb-2">
                    <div className="bg-blue-100 p-2 border-round-lg mr-3"><span style={{ color: '#03438F' }}>🏃</span></div>
                    <span className="text-700">Athletics Track</span>
                  </div>
                  <div className="col-12 md:col-6 flex align-items-center mb-2">
                    <div className="bg-blue-100 p-2 border-round-lg mr-3"><span style={{ color: '#03438F' }}>🏀</span></div>
                    <span className="text-700">Indoor/Outdoor Courts</span>
                  </div>
                  <div className="col-12 md:col-6 flex align-items-center mb-2">
                    <div className="bg-blue-100 p-2 border-round-lg mr-3"><span style={{ color: '#03438F' }}>🏊</span></div>
                    <span className="text-700">Swimming Pool</span>
                  </div>
                  <div className="col-12 md:col-6 flex align-items-center mb-2">
                    <div className="bg-blue-100 p-2 border-round-lg mr-3"><span style={{ color: '#03438F' }}>🏆</span></div>
                    <span className="text-700">Qualified Coaches</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* 6. Arts & Music - Image Right */}
          <div className="mb-5 bg-white border-round-2xl shadow-2 overflow-hidden">
            <div className="flex flex-column lg:flex-row-reverse">
              <div className="lg:col-6 relative p-0">
                <img
                  src="/images/dis (3).jpg"
                  alt="Arts & Music"
                  className="w-full h-full object-cover"
                  style={{ minHeight: '400px' }}
                />
                <div className="absolute top-3 right-3 bg-blue-600 text-white px-3 py-2 border-round-xl font-bold">
                  🎨 Creative Arts
                </div>
              </div>
              <div className="lg:col-6 p-5 flex flex-column justify-content-center">
                <h3 className="text-3xl font-bold mb-3 text-primary" style={{ color: '#03438F' }}>Arts & Music Studio</h3>
                <p className="text-lg text-700 mb-4 line-height-3">
                  Unleash creativity in our dedicated arts and music spaces. From painting and sculpture to dance and musical performances, we provide the perfect environment for artistic expression.
                </p>
                <div className="grid mb-4">
                  <div className="col-12 md:col-6 flex align-items-center mb-2">
                    <div className="bg-orange-100 p-2 border-round-lg mr-3"><span style={{ color: '#F57A25' }}>🎭</span></div>
                    <span className="text-700">Dance Studio</span>
                  </div>
                  <div className="col-12 md:col-6 flex align-items-center mb-2">
                    <div className="bg-orange-100 p-2 border-round-lg mr-3"><span style={{ color: '#F57A25' }}>🎹</span></div>
                    <span className="text-700">Music Room</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* 7. Excursions & Educational Tours - Image Left */}
          <div className="mb-5 bg-white border-round-2xl shadow-2 overflow-hidden">
            <div className="flex flex-column lg:flex-row">
              <div className="lg:col-6 relative p-0">
                <img
                  src="/images/excur.png"
                  alt="Educational Tours"
                  className="w-full h-full object-cover"
                  style={{ minHeight: '400px' }}
                />
                <div className="absolute top-3 left-3 bg-orange-500 text-white px-3 py-2 border-round-xl font-bold">
                  🚌 Beyond Classrooms
                </div>
              </div>
              <div className="lg:col-6 p-5 flex flex-column justify-content-center">
                <h3 className="text-3xl font-bold mb-3 text-primary" style={{ color: '#03438F' }}>Excursions & Tours</h3>
                <p className="text-lg text-700 mb-4 line-height-3">
                  Learning extends beyond the classroom. Visits to historical sites, science centres, and cultural institutions provide students with real‑world experiences that promote independence and a broader world view.
                </p>
              </div>
            </div>
          </div>

          {/* Commitment Section (Fixed Visibility) */}
          <div className="text-center mt-7 mb-4">
            <div className="max-w-4xl mx-auto border-round-3xl p-6 shadow-4" style={{ backgroundColor: '#03438F' }}>
              <h2 className="text-3xl font-bold mb-4 text-white">Our Commitment to Excellence</h2>
              <p className="text-xl line-height-3 mb-3 text-blue-100">
                Every aspect of our infrastructure reflects our commitment to providing quality education in a nurturing and inspiring environment.
              </p>
              <p className="text-lg line-height-3 text-blue-200">
                We continuously upgrade our facilities to meet evolving educational needs, ensuring students always have access to the best resources for learning and growth.
              </p>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
};

export default Infrastructure;